import { render, staticRenderFns } from "./Patent.vue?vue&type=template&id=945964a4&scoped=true"
import script from "./Patent.vue?vue&type=script&lang=js"
export * from "./Patent.vue?vue&type=script&lang=js"
import style0 from "./Patent.vue?vue&type=style&index=0&id=945964a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945964a4",
  null
  
)

export default component.exports